import {SecureTable} from '../secure.table';
import {ProdRequest} from '../../interfaces/product-management/prod-request';
import {db} from '../db.service';
import {Injectable} from '@angular/core';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {ProdRequestFactory} from '../../factories/product-management/prod-request-factory';

@Injectable({
  providedIn: 'root'
})
export class ProdRequestsTable extends SecureTable<ProdRequest> {
  public constructor() {
    super(db.prodRequests);

    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<ProdRequest>({
        api: ['prod-requests'],
        fromObject: ProdRequestFactory.fromObject,
        toRemote: ProdRequestFactory.toRemote
      })
    };
  }

  /**
   *
   * @param customerIds
   * @param withoutSynced
   */
  public async removeByCustomerIds(customerIds: number[], withoutSynced: boolean = true): Promise<void> {
    const prodRequests = await this.table.where('customerId').anyOf(customerIds).toArray();
    await this.removeMany(prodRequests.map(({ uuid }) => uuid), withoutSynced);
  }

  /**
   *
   * @param customerId
   */
  public getByCustomerId(customerId: number): Promise<ProdRequest[]> {
    return this.table.where('customerId').equals(customerId).toArray();
  }

  /**
   *
   * @param employeeId
   */
  public getByEmployeeId(employeeId: number): Promise<ProdRequest[]> {
    return this.table.where('employeeId').equals(employeeId).toArray();
  }

}


